/*
 * @Author: Teemo Ding
 * @Date: 2022-05-05 15:25:38
 * @LastEditTime: 2022-05-06 10:27:59
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/Components/ExportCommunicationRecords/index.tsx
 */
import React, { Fragment } from 'react';
import { Form, message } from 'antd';
import { useRequest } from 'ahooks';
import { convertRes2Blob } from 'src/tools/helper';
import { exportCommunication } from '@/src/request/auditTrail/communication';
import { RadioGroup, RadioItem, ModalFooter } from '@/src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

enum IScope {
  Selected = 'Selected',
  All = 'All',
  Current = 'Current',
}
enum IFormat {
  CSV = 'CSV',
  Excel = 'Excel',
}

const ExportCommunicationRecords = ({ onCancel, selectedRowKeys, current }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();

  const { run: _exportCommunication, loading } = useRequest(
    (data) => exportCommunication(data),
    {
      manual: true,
      onSuccess: (res) => {
        convertRes2Blob(res);
        message.success(getI18n('general.done'));
        onCancel();
      },
    },
  );

  const onFinish = (values) => {
    _exportCommunication({
      ...values,
      ...(values.scope == IScope.Current && { logUuids: current }),
      ...(values.scope == IScope.Selected && { logUuids: selectedRowKeys }),
    });
  };

  return (
    <Fragment>
      <Form
        form={form}
        name='exportCommunicationRecords'
        onFinish={onFinish}
        className={css.exportCommunicationRecords}>
        <Form.Item
          name='scope'
          label={getI18n('communication.exportCommunicationRecords.export')}
          initialValue={IScope.Current}
          labelCol={{ span: 24 }}>
          <RadioGroup className={css.item}>
            <RadioItem value={IScope.Current}>
              {getI18n('communication.exportCommunicationRecords.currentPage')}
            </RadioItem>
            <RadioItem
              disabled={selectedRowKeys.length === 0}
              value={IScope.Selected}>
              {getI18n(
                'communication.exportCommunicationRecords.selectedRecords:',
              )}{' '}
              {selectedRowKeys.length}
            </RadioItem>
          </RadioGroup>
        </Form.Item>
        <Form.Item
          name='format'
          label={getI18n('communication.exportCommunicationRecords.exportas')}
          initialValue={IFormat.CSV}
          labelCol={{ span: 24 }}>
          <RadioGroup className={css.item}>
            <RadioItem value={IFormat.CSV}>
              {getI18n(
                'communication.exportCommunicationRecords.plainCSVfile(utf-8)',
              )}
            </RadioItem>
            <RadioItem value={IFormat.Excel}>
              {getI18n('communication.exportCommunicationRecords.excel(.xlsx)')}
            </RadioItem>
          </RadioGroup>
        </Form.Item>
      </Form>
      <ModalFooter
        loading={loading}
        onOk={() => form.submit()}
        okText={getI18n('communication.exportCommunicationRecords.exportFile')}
        onCancel={onCancel}
      />
    </Fragment>
  );
};

export default ExportCommunicationRecords;
